module.exports = __webpack_public_path__ + "assets/imgs/logos/prisma.ceab4c7ba199aa4e036a770f12ce70b5.svg";